<template>
  <div class="fault-self-handle">
    <!-- 待处理：自行处理 -->
    <el-form
      v-if="variant === 'self'"
      ref="selfFormRef"
      :model="selfForm"
      :rules="selfRules"
      label-width="110px"
    >
      <el-form-item label="处置措施" prop="handleDesc">
        <el-input v-model="selfForm.handleDesc" type="textarea" :rows="3" placeholder="请描述处置措施" />
      </el-form-item>
      <el-form-item label="处置后照片">
        <ImageUploader v-model="selfForm.handleImages" />
      </el-form-item>
    </el-form>

    <!-- 已上报：维修情况登记 -->
    <el-form
      v-if="variant === 'repair'"
      ref="repairFormRef"
      :model="repairForm"
      :rules="repairRules"
      label-width="110px"
    >
      <el-form-item label="实际维修情况" prop="handleDesc">
        <el-input v-model="repairForm.handleDesc" type="textarea" :rows="3" placeholder="请填写实际维修处置情况" />
      </el-form-item>
      <el-form-item label="维修后照片">
        <ImageUploader v-model="repairForm.handleImages" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'FaultHandleFix',
  props: {
    /** self：待处理自行处理；repair：已上报维修登记 */
    variant: {
      type: String,
      required: true,
      validator: (v) => ['self', 'repair'].includes(v)
    }
  },
  data () {
    return {
      selfForm: { handleDesc: '', handleImages: [] },
      selfRules: { handleDesc: [{ required: true, message: '请填写处置措施', trigger: 'blur' }] },
      repairForm: { handleDesc: '', handleImages: [] },
      repairRules: { handleDesc: [{ required: true, message: '请填写实际维修情况', trigger: 'blur' }] }
    };
  },
  methods: {
    /**
     * 校验当前表单，成功则 resolve 处置提交所需字段
     */
    validateAndGetPayload () {
      if (this.variant === 'self') {
        return new Promise((resolve, reject) => {
          this.$refs.selfFormRef.validate((valid) => {
            if (!valid) return reject(new Error('validation'));
            resolve({
              handleDesc: this.selfForm.handleDesc,
              handleImages: this.selfForm.handleImages
            });
          });
        });
      }
      return new Promise((resolve, reject) => {
        this.$refs.repairFormRef.validate((valid) => {
          if (!valid) return reject(new Error('validation'));
          resolve({
            handleDesc: this.repairForm.handleDesc,
            handleImages: this.repairForm.handleImages
          });
        });
      });
    }
  }
};
</script>
